import { render } from "./StaffSearch.vue?vue&type=template&id=de610810&scoped=true"
import script from "./StaffSearch.vue?vue&type=script&lang=js"
export * from "./StaffSearch.vue?vue&type=script&lang=js"

import "./StaffSearch.vue?vue&type=style&index=0&id=de610810&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de610810"]])

export default __exports__